<!-- Security - CAS options -->
<form  #casForm="ngForm" class="mt-20">
  <div class="form">
    <div class="security-category">
      <h5>{{locale.LABEL_CAS}} {{locale.LABEL_CONFIGURATION}}</h5>
      <!-- server url -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required" for="wm-security-cas-url">{{locale.LABEL_CAS_URL}}:
        </label>

        <div class="col-xs-9">
          <input name="wm-security-cas-url" type="text" placeholder={{security.placeholder.CAS_url}}
            class="form-control app-textbox wm-security-url" [(ngModel)]="security.serverUrl"
            (change)="populateUrls('{{security.serverUrl}}');" (ngModelOptions)="{'updateOn' : 'blur'}" />
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_CAS_SERVER_URL}}"
            class="wm-icon wms wms-help ml-5"></i>
        </div>
      </div>
      <!-- login url -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required"
          for="wm-security-cas-login-url">{{locale.LABEL_CAS_LOGIN_URL}}: </label>
        <div class="col-xs-9">
          <input name="wm-security-cas-login-url" type="text" placeholder={{security.placeholder.CAS_loginUrl}}
            class="form-control app-textbox wm-security-url" [(ngModel)]="security.loginUrl" />
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_CAS_LOGIN_URL}}"
            class="wm-icon wms wms-help ml-5"></i>
        </div>
      </div>
      <!-- logout url -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required"
          for="wm-security-cas-logout-url">{{locale.LABEL_CAS_LOGOUT_URL}}: </label>
        <div class="col-xs-9">
          <input name="wm-security-cas-logout-url" type="text" placeholder={{security.placeholder.CAS_logoutUrl}}
            class="form-control app-textbox wm-security-url" [(ngModel)]="security.logoutUrl" />
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_CAS_LOGOUT_URL}}"
            class="wm-icon wms wms-help ml-5"></i>
        </div>
      </div>
      <!-- validation url -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required"
          for="wm-security-cas-validation-url">{{locale.LABEL_CAS_VALIDATION_URL}}: </label>

        <div class="col-xs-9">
          <input name="wm-security-cas-validation-url" type="text" placeholder={{security.placeholder.CAS_validationUrl}}
            class="form-control app-textbox wm-security-url" [(ngModel)]="security.validationUrl" />
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_CAS_VALIDATION_URL}}"
            class="wm-icon wms wms-help ml-5"></i>
        </div>
      </div>

      <!-- Service Param -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required"
          for="wm-security-cas-service-parameter">{{locale.LABEL_CAS_SERVICE_PARAM}}:</label>
        <div class="col-xs-9">
          <input name="wm-security-cas-service-parameter" type="text" class="form-control app-textbox"
            [(ngModel)]="security.serviceParameter" />
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_CAS_SERVICE_PARAM}}"
            class="wm-icon wms wms-help ml-5"></i>

        </div>
      </div>

      <!-- Artifact Param -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required"
          for="wm-security-artifact-parameter">{{locale.LABEL_CAS_ARTIFACT_PARAM}}:</label>

        <div class="col-xs-9">
          <input name="wm-security-artifact-parameter" type="text" class="form-control app-textbox"
            [(ngModel)]="security.artifactParameter" />
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_CAS_ARTIFACT_PARAM}}"
            class="wm-icon wms wms-help ml-5"></i>

        </div>
      </div>

      <div class="form-group app-composite-widget clearfix" title="{{locale.MESSAGE_CAS_FETCH_ROLE_MESSAGE}}">
        <div class="col-xs-9 col-xs-push-3 test-connect">
          <button id="wm-security-ldap-test-connection" (click)="testCasConnection()"
            class="button-primary">{{locale.LABEL_TEST_CONNECTION}}</button>
          <div class="{{statusClass}} status"><i class="wm-icon wms {{iconClass}}"></i> <span>{{statusMessage}}</span>
          </div>
        </div>
        <p class="text-muted col-xs-9 col-xs-push-3 note-text">{{locale.LABEL_CAS_TEST_CONNECTION}}</p>
      </div>
      <wms-message *ngIf="!hideMessage" hideclose="true" [scopeDataset]="message"></wms-message>
      <hr>
    </div>

    <div class="security-category">
      <h5>{{locale.LABEL_ROLE}}</h5>

      <!-- Enable Role Mapping-->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3">{{locale.LABEL_SEARCH_USER_ROLE}}: </label>

        <div class="col-xs-9">
          <wms-toggle id="wm-security-ad-user-roles-toggle" class="switch" name="wm-role-config"
            [model]="security.roleMappingEnabled" [onLabel]="'On'" [offLabel]="'Off'"
            (onChange)="security.roleMappingEnabled = $event;"></wms-toggle>
        </div>
      </div>
      <!-- Search User Role Options-->
      <div *ngIf="security.roleMappingEnabled">

        <div class="form-group app-composite-widget clearfix">
          <label class="control-label app-label col-xs-3"
            for="wm-sec-select-search-user-role-provider">{{locale.LABEL_SELECT_USER_ROLE_PROVIDER}}: </label>

          <div class="col-xs-9">
            <select name="wm-sec-select-search-user-role-provider" class="form-control app-select"
              [(ngModel)]="security.roleProvider">
              <option *ngFor="let option of security.userCASRoleProviders">{{option}}</option>
            </select>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_CAS_ROLE_PROVIDER}}"
              class="wm-icon wms wms-help ml-5"></i>
          </div>
        </div>
        <div [ngSwitch]="security.roleProvider">
          <div *ngSwitchCase="'CAS'">
            <div class="form-group app-composite-widget clearfix">
              <label class="control-label app-label col-xs-3 required"
                for="wm-sec-grp-search-base">{{locale.LABEL_ROLE_ATTRIBUTE_NAME}}: </label>
              <div class="col-xs-9">
                <wms-typeahead style="display: inline-block;" name="wm-security-cas-role" placeholder="{{locale.LABEL_ROLE_ATTRIBUTE_NAME}}"
                  [model]="security.roleAttributeName" [disable]="statusClass === 'text-info'"
                  [options]="security.attributes" (onSelect)="handleModelChange($event)"> </wms-typeahead>
                <i placement="right" [tooltipAppendToBody]="true"
                  tooltip="{{locale.LABEL_HELP_CAS_ROLE_ATTRIBUTE_NAME}}" class="wm-icon wms wms-help ml-5"></i>
              </div>
            </div>
          </div>
          <div class="security-sub-category" *ngSwitchCase="'Database'">
            <!-- Roles By SQL Query -->
            <wms-database [securityProps]="securityProps" [authInfo]="authInfo"></wms-database>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>